import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16" data-testid="not-found-page">
        <div className="data-card p-12 text-center max-w-lg mx-auto">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-yellow-500/20 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-yellow-400" />
          </div>
          <h1 className="text-3xl font-bold mb-4">404</h1>
          <h2 className="text-xl font-semibold mb-2">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button className="neon-glow">
                Back to Explorer
              </Button>
            </Link>
            <Link to="/blocks">
              <Button variant="outline">
                View Blocks
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
